import React, { useState } from "react";
import {useForm} from "react-hook-form";
import axios from 'axios';
import { Link, useHistory } from "react-router-dom";
import { LinkContainer } from 'react-router-bootstrap'

import {
    Container,
    Button,
    Form,
    Col,
    Row,
  } from "react-bootstrap";

// import { css } from "@emotion/core";
// import CircleLoader from "react-spinners/CircleLoader";
import SyncLoader from "react-spinners/SyncLoader";
import ReactGA from 'react-ga';



export default function Login() {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const [loading, setLoading] = useState(false);
    const [wrongAccountInfo, setwrongAccountInfo] = useState(false);
    let history = useHistory();
    const {register, handleSubmit} = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        setwrongAccountInfo(false);
        axios.post('https://uae-dentist-backend.herokuapp.com/login', data)
        .then(function (response) {
            console.log(response.data)
            const token = response.data.token;
            localStorage.setItem('token', token);
            history.push({
                pathname: '/logged-in/calendar',
                state: { clinicData: response.data.clinicData }
            });
        })
        .catch(function (error) {
            setLoading(false);
            setwrongAccountInfo(true);
            console.log('You entered the wrong info')
            console.log(error);
        });
    }

    return (
    <Container className="mt-5">
        <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group as={Row} controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
                Email
            </Form.Label>
            <Col sm={6}>
            <Form.Control required type="email" name='email' placeholder="Email" ref={register ({required:true})} />
            </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formHorizontalPassword">
            <Form.Label column sm={2}>
            Password
            </Form.Label>
            <Col sm={6}>
            <Form.Control required type="password" name='password' placeholder="Password" ref={register ({required:true})} />
            { wrongAccountInfo && "Either the email or the password is wrong"}
            </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="formHorizontalCheck">
            <Col sm={{ span: 4, offset: 2 }}>
            <Form.Check label="Remember me" />
            </Col>
            <Col>
            <Link to="/forgot-password" className='mt-3 mb-2'>Forgot Password?</Link>
            </Col>
        </Form.Group>

        <Form.Group as={Row}>
            <Col sm={{ span: 10, offset: 2 }}>
            <Button className='ml-0' variant="primary" type="submit">Log in</Button>

        <div className='font-weight-normal'>
            <p className='mt-4 mb-0'>Do not have an account?</p>
            <LinkContainer to="/register">
                <Button className='ml-0 text-capitalize '>
                    Register my practice
                </Button>
            </LinkContainer>
        </div>

        </Col>
        </Form.Group>
        <div className='mt-5'>
          <SyncLoader
            size={15}
            margin={2}
            color={"#123abc"}
            loading={loading}
          />
        </div>

        </Form>




    </Container>
    )
}